export const dateFormats = {
  date: "MM-DD-YYYY",
  uiDate: "MM/DD/YYYY",
  uiDateWeek: "ddd, MM/DD/YYYY",
  uiTime: "hh:mm a",
  uiDateTime: "MM/DD/YY hh:mm a",
  apiDate: "YYYY-MM-DD",
  apiDateTime: "YYYY-MM-DD hh:mm:ss a",
};

export default dateFormats;